<template>
  <div class="column-attr">
    <h3>列属性</h3>
     <div class="column-content">
        <el-form :model="column" class="form-column" :inline="true" ref="columnForm" label-position="left" label-width="65px">
          <div class="group">
            <el-form-item class="mb15" label="列名" prop="name" :rules="{required: true, message: '列名不能为空', trigger: 'blur'}">
              <el-input v-model="column.name"></el-input>
            </el-form-item>
            <el-form-item class="mb15" label="隐藏">
              <el-checkbox v-model="column.hidden"></el-checkbox>
            </el-form-item>
            <!-- 隐藏的计算公式-->
            <el-form-item :class="['mb15', 'label-position']" v-show="column.hidden">
              <template slot="label">
                <el-tooltip content="可双击设置隐藏条件，条件成立时该列将被隐藏" placement="bottom-start" class="tooltip">
                  <span class="fa fa-exclamation-circle"></span>
                </el-tooltip>
              </template>
              <div class="hidden-expression" @dblclick="openSeniorFilter" v-html="seniorConvert(column.hiddenExpressionText)"></div>
            </el-form-item>
            <el-form-item class="mb15" label="列宽">
              <el-input v-model="dataFormatPage.dataFormat.width"></el-input>
            </el-form-item>
            <el-form-item class="mb15" label="对齐方式">
              <el-select v-model="dataFormatPage.dataFormat.align">
                <el-option label="居中" value="center"></el-option>
                <el-option label="左对齐" value="left"></el-option>
                <el-option label="右对齐" value="right"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="mb15" label="自动换行">
              <el-checkbox v-model="column.lineWrap"></el-checkbox>
            </el-form-item>
          </div>
          <div :class="more?'one':'more'" @click="more=!more">{{more?'收起':'更多设置'}}
            <i :class="more?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
          </div>
          <el-collapse-transition>
            <div v-show="more">
              <div class="group">
                <p class="title">表头拆分</p>
                <el-form-item label="拆分依据" class="split-item">
                  <el-select clearable v-model="column.basis" @clear="column.timeFormat=''" filterable>
                    <el-option v-for="column in this.reportService.options.allAchivedColumns" :key="column.id" :label="column.name" :value="column.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="时间单位" v-if="column.basis">
                 <el-select clearable v-model="column.timeFormat">
                  <el-option label="年" value="1"></el-option>
                  <el-option label="年、月" value="2"></el-option>
                  <el-option label="年、月、日" value="3"></el-option>
                  <el-option label="季度" value="4"></el-option>
                 </el-select>
                </el-form-item>
              </div>
              <div class="group item-dataFormatFormat">
              <p class="title">格式类型</p>
              <el-form-item label="数据格式">
                  <el-select clearable v-model="dataFormatPage.dataFormat.dataType">
                    <el-option label="百分比" value="percent"></el-option>
                    <el-option label="整数" value="int"></el-option>
                    <el-option label="小数" value="decimal"></el-option>
                    <el-option label="日期" value="date"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="日期格式" v-if='dataFormatPage.dataFormat.dataType==="date" '>
                  <el-select v-model="dataFormatPage.dataFormat.dataformat">
                    <el-option label="YYYY-MM-DD" value="DA"></el-option>
                    <el-option label="YYYY年MM月DD日" value="DB"></el-option>
                    <el-option label="YYYY年MM月" value="DC"></el-option>
                    <el-option label="YYYY年下半年" value="DE"></el-option>
                    <el-option label="YYYY年X季度" value="DD"></el-option>
                    <el-option label="MM月DD日" value="DF"></el-option>
                    <el-option label="MM月" value="DG"></el-option>
                    <el-option label="周X" value="DH"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="计算方式" v-if='dataFormatPage.dataFormat.dataType==="percent"  || dataFormatPage.dataFormat.dataType==="decimal"'>
                  <el-select v-model="dataFormatPage.dataFormat.roundWay">
                    <el-option label="四舍五入" value="rounding"></el-option>
                    <el-option label="向上取整" value="ceil"></el-option>
                    <el-option label="向下取整" value="floor"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="小数位数" clearable v-if='dataFormatPage.dataFormat.dataType==="percent" || dataFormatPage.dataFormat.dataType==="decimal"'>
                  <el-input v-model="dataFormatPage.dataFormat.decimalDigits"></el-input>
                </el-form-item>
              </div>
              <div class="group">
                <p class="title">自定义显示</p>
                <template v-for="(displayFormat,index) in displayFormatPage.displayFormats">
                  <el-form-item :key="displayFormat.id" class="item-displayFormat">
                      <span class="el-icon-plus" @click="addDisplayFormat(index)"></span>
                      <span class="el-icon-minus" @click="delDisplayFormat(index)"></span>
                    <el-form-item label="显示为">
                      <el-input class="wide-input" v-model="displayFormat.value"></el-input>
                    </el-form-item>
                    <el-form-item label="字段值">
                      <el-select  v-model="displayFormat.type" placeholder="显示条件" class="narrow-select">
                        <el-option label="大于" value=">"></el-option>
                        <el-option label="小于" value="<"></el-option>
                        <el-option label="等于" value="=="></el-option>
                        <el-option label="不等于" value="!="></el-option>
                        <el-option label="大于等于" value=">="></el-option>
                        <el-option label="小于等于" value="<="></el-option>
                        <el-option label="包含" value="include"></el-option>
                        <el-option label="不包含" value="exclude"></el-option>
                      </el-select>
                      <el-input class="narrow-input" v-model="displayFormat.condition" placeholder="显示值"></el-input>
                    </el-form-item>
                  </el-form-item>
                </template>
              </div>
              <div class="group color-content">
                <p class="title">条件预警</p>
                <template v-for="(colorFormat,index) in colorformatPage.colorFormats">
                  <el-form-item :key="colorFormat.id" class="color-form">
                    <span class="el-icon-plus" @click="addColorFormat(index)"></span>
                    <span class="el-icon-minus" @click="delColorFormat(index)"></span>
                    <el-form-item label="">
                      <el-select class="format-selece wide-input" v-model="colorFormat.warningWaySelect" placeholder="变色类型">
                        <el-option label="数据变色" value="data"></el-option>
                        <el-option label="整行变色" value="rows"></el-option>
                        <el-option label="整列变色" value="columns"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-input class='narrow-input' v-model="column.name" disabled></el-input>
                      <el-select class="format-selece narrow-select" v-model="colorFormat.color" placeholder="颜色">
                        <el-option label="红色" value="#FFB6C1"></el-option>
                        <el-option label="蓝色" value="#6495ED"></el-option>
                        <el-option label="紫色" value="#9370DB"></el-option>
                        <el-option label="黄色" value="#F0E68C"></el-option>
                        <el-option label="绿色" value="#AFEEEE"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item v-if='colorFormat.warningWaySelect!=="columns"'>
                      <el-select class="narrow-select" v-model="colorFormat.type" placeholder="变色条件">
                        <el-option label="大于" value=">"></el-option>
                        <el-option label="小于" value="<"></el-option>
                        <el-option label="等于" value="=="></el-option>
                        <el-option label="不等于" value="!="></el-option>
                        <el-option label="大于等于" value=">="></el-option>
                        <el-option label="小于等于" value="<="></el-option>
                        <el-option label="包含" value="include"></el-option>
                        <el-option label="不包含" value="exclude"></el-option>
                      </el-select>
                      <el-input class='narrow-small-input' v-if='colorFormat.warningText' v-model="colorFormat.condition" placeholder="请输入值"></el-input>
                      <el-select v-else class="narrow-small-select" v-model="colorFormat.condition" placeholder="请选择列" filterable>
                        <el-option v-for="column in columns" :key="column.id" :label="column.name" :value="column.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <span v-if='colorFormat.warningWaySelect!=="columns"' class="warning-text" @click="colorFormat.warningText=!colorFormat.warningText;colorFormat.condition=''">
                      <span v-if='!colorFormat.warningText'>列</span>
                      <span v-else>值</span>
                    </span>
                  </el-form-item>
                </template>
              </div>
            </div>
          </el-collapse-transition>
        </el-form>
     </div>

    <div class="buttons">
      <el-button type="primary" @click="saveAttr">保存</el-button>
      <el-button @click="closeAttr">关闭</el-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ColorFormat from '@/store/report/colorFormat.js'
import DisplayFormat from '@/store/report/displayFormat.js'
import DataFormat from '@/store/report/dataFormat.js'
export default {
  name: 'column-panel',
  inject: ['reportService'],
  data () {
    let id = this.reportService.options.leftPanel.id
    const column = _.cloneDeep(this.reportService.report.columns.find(m => m.id === id))
    let colorFormats = column.format.colorFormats || []
    let displayFormats = column.format.displayFormats || []
    let dataFormat = column.format.dataFormat || {}
    if (!colorFormats.length) {
      let colorFormat = new ColorFormat()
      colorFormats.push(colorFormat)
    }
    if (!displayFormats.length) {
      let displayFormat = new DisplayFormat()
      displayFormats.push(displayFormat)
    }
    if (!Object.keys(dataFormat).length) {
      dataFormat = new DataFormat()
    }
    column.format = {
      colorFormats: colorFormats,
      displayFormats: displayFormats,
      dataFormat: dataFormat
    }
    return {
      column,
      colorformatPage: { colorFormats: colorFormats },
      displayFormatPage: { displayFormats: displayFormats },
      dataFormatPage: {dataFormat: dataFormat},
      more: false
    }
  },
  methods: {
    addColorFormat (index) {
      let colorFormat = new ColorFormat()
      //  在当前这行后面插入一个colorFormat
      this.colorformatPage.colorFormats.splice(index + 1, 0, colorFormat)
    },
    delColorFormat (index) {
      if (this.colorformatPage.colorFormats.length > 1) {
        this.colorformatPage.colorFormats.splice(index, 1)
      } else {
        this.$message({
          showClose: true,
          message: '至少保留一行',
          type: 'info'
        })
      }
    },
    addDisplayFormat (index) {
      let displayFormat = new DisplayFormat()
      //  在当前这行后面插入一个displayFormat
      this.displayFormatPage.displayFormats.splice(index + 1, 0, displayFormat)
    },
    delDisplayFormat (index) {
      if (this.displayFormatPage.displayFormats.length > 1) {
        this.displayFormatPage.displayFormats.splice(index, 1)
      } else {
        this.$message({
          showClose: true,
          message: '至少保留一行',
          type: 'info'
        })
      }
    },
    openSeniorFilter () {
      this.$Popup.calculation({
        parameter: {
          title: '表达式设计',
          expression: this.column.hiddenExpressionText || '',
          dataSource: this.reportService.getReportJoinTables(),
          functionType: ['simple', 'math', 'text', 'date', 'concat', 'logic', 'system'],
          calculationType: 'sql'
        },
        width: '1000px'
      }).then((data) => {
        if (data.action === 'confirm') {
          this.$set(this.column, 'hiddenExpressionText', data.value)
        }
      })
    },
    seniorConvert (expression) {
      // 转换
      if (expression) {
        expression.match(/\$\{(.+?)\}/g) && expression.match(/\$\{(.+?)\}/g).map(el => {
          let codeAttr = el.replace(/[${}]/g, '').split(',')
          let code = `&nbsp;<span contenteditable='false' dataId=${codeAttr[0]} name=${codeAttr[1]} type=${codeAttr[2]}>${codeAttr[1]}</span>&nbsp;`
          expression = expression.replace(el, code)
        })
        return expression
      }
    },
    saveAttr () {
      this.$refs['columnForm'].validate(async (valid) => {
        if (valid) {
          let colorFormats = this.colorformatPage.colorFormats
          let displayFormats = this.displayFormatPage.displayFormats
          let dataFormat = this.dataFormatPage.dataFormat
          let columnFormat = {
            colorFormats,
            displayFormats,
            dataFormat
          }
          this.column.format = columnFormat
          this.reportService.report.columns.find(m => m.id === this.column.id).format = columnFormat
          let pinyin = await this.reportService.getPinyinByHanzi(this.column.name)
          _.merge(this.column, {...pinyin})
          this.reportService.createOrUpdate(this.column)
          this.closeAttr()
        } else {
          return false
        }
      })
    },
    closeAttr () {
      this.reportService.closePanel()
    }
  },

  watch: {
    'reportService.options.leftPanel.id' (val, old) {
      if (val) {
        if (old) {
          let oldColumn = this.reportService.report.columns.find(m => m.id === old)
          if (oldColumn.format.colorFormats.length) {
            if (JSON.stringify(oldColumn.format.dataFormat) !== JSON.stringify(this.column.format.dataFormat) ||
            JSON.stringify(oldColumn.format.displayFormats) !== JSON.stringify(this.column.format.displayFormats) ||
            JSON.stringify(oldColumn.format.colorFormats) !== JSON.stringify(this.column.format.colorFormats)) {
              this.$message.info('请先保存当前列属性')
              return false
            }
          } else {
            if (this.column.format.dataFormat.width || this.column.format.dataFormat.align !== 'center') {
              this.$message.info('请先保存当前列属性')
              return false
            }
          }
          if (oldColumn.hidden !== this.column.hidden ||
          oldColumn.name !== this.column.name ||
           oldColumn.basis !== this.column.basis || oldColumn.timeFormat !== this.column.timeFormat) {
            this.$message.info('请先保存当前列属性')
            return false
          }
        }
        const column = _.cloneDeep(this.reportService.report.columns.find(m => m.id === val))
        let colorFormats = column.format.colorFormats || []
        let displayFormats = column.format.displayFormats || []
        let dataFormat = column.format.dataFormat || {}
        if (!colorFormats.length) {
          let colorFormat = new ColorFormat()
          colorFormats.push(colorFormat)
        }
        if (!displayFormats.length) {
          let displayFormat = new DisplayFormat()
          displayFormats.push(displayFormat)
        }
        if (!Object.keys(dataFormat).length) {
          dataFormat = new DataFormat()
        }
        column.format = {
          colorFormats: colorFormats,
          displayFormats: displayFormats,
          dataFormat: dataFormat
        }
        this.column = column
        this.colorformatPage = { colorFormats: colorFormats }
        this.displayFormatPage = { displayFormats: displayFormats }
        this.dataFormatPage = {dataFormat: dataFormat}
        this.more = false
      }
    }
  }
}
</script>

<style lang="scss">
   .column-attr {
    height: 100%;

    h3 {
      padding: 10px 15px;
      background-color: #ecf5ff;
      font-weight: normal;
      text-align: center;
      color: #55acf1;
      border-bottom: 2px solid #54abf1;
    }

    .column-content {
      height: 80%;
      overflow: hidden;
      overflow-y: auto;

      .form-column {
        .group {
          padding: 10px 14px;
          border-bottom: 1px solid #EBEEF5;
          &.item-dataFormatFormat {
            .el-form-item {
             margin-bottom: 10px;
            }
          }
          .split-item {
            margin-bottom: 8px;
          }
        }

        .el-form-item.mb15 {
          margin-bottom: 15px;

          .el-form-item__label::before {
            display: none;
          }
          &.label-position{
            .el-form-item__label{
              text-align: end;
            }
          }
          .hidden-expression{
            border: 1px solid #c0c4cc;
            background-color: rgb(235, 235, 228);
            -ms-text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width:142px;
            height:24px;
            line-height: 24px;
            border-radius: 4px;
            cursor: pointer;
          }
        }

        p.title {
          font-size: 12px;
          color: #999999;
          margin-bottom: 3px;
        }

        .one,
        .more {
          color: #BCBCBC;
          font-size: 12px;
          text-align: center;
          cursor: pointer;
          margin-top: 10px;

          i {
            color: #BCBCBC;
          }

          &:hover {
            color: #54ABF1;

            i {
              color: #54ABF1;
            }
          }

          &:active {
            color: #1989fa;

            i {
              color: #1989fa;
            }
          }
        }

        .el-form-item {
          margin-right: 0px;
          margin-bottom: 0;

          .el-input {
            width: 142px;
            height: 24px;
            line-height: 24px;

            .el-input__inner {
              height: 24px;
              line-height: 24px;
            }

            &.wide-input {
              width: 202px;
            }

            &.narrow-input {
              width: 98px;
            }
          }

          .el-select {
            &.wide-input {
              width: 202px;

              .el-input {
                width: 202px;
              }
            }
          }

          .narrow-select {
            width: 98px;

            .el-input {
              width: 98px;
            }
          }

          .narrow-input {
            width: 98px;
          }

          .narrow-small-input {
            width: 83px;
          }

          .narrow-small-select {
            width: 83px;

            .el-input {
              width: 83px;
            }
          }

          .el-form-item__label {
            font-size: 12px;
          }

          &.item-displayFormat {
            padding-bottom: 12px;
            border-bottom: 1px solid #EBEEF5;

            .el-form-item__content {
              position: relative;
            }

            span.el-icon-plus {
              position: absolute;
              top: 10px;
              right: 16px;
              color: #76E0BC;
              cursor: pointer;
              font-weight: 700;
              font-size: 10px
            }

            span.el-icon-minus {
              position: absolute;
              top: 10px;
              right: 0;
              color: #FF0000;
              font-weight: 700;
              cursor: pointer;
              font-size: 10px
            }
          }

          &.color-form {
            border-bottom: 1px solid #EBEEF5;
            margin-top: 22px;

            &:nth-last-child() {
              border-bottom: none;
            }

            .el-form-item {
              margin-bottom: 8px;
            }

            .el-form-item__content {
              position: relative;
            }

            span.el-icon-plus {
              position: absolute;
              top: -16px;
              right: 16px;
              color: #76E0BC;
              cursor: pointer;
              font-weight: 700;
              font-size: 10px
            }

            span.el-icon-minus {
              font-size: 10px;
              position: absolute;
              top: -16px;
              right: 0;
              color: #FF0000;
              font-weight: 700;
              cursor: pointer;
            }
          }
        }
      }
    }

    .buttons {
      height: 10%;
      bottom: 0;
      left: 0;
      right: 0;
      position: absolute;
      background: #fff;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      button {
        width: 72px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/column-panel.vue